import React from 'react';

/**
 * Single-line trust strip above the map (DESIGN_ROADMAP §5).
 * "<N> readings · <M> stations · CC-BY-4.0 · DOI: …"
 *
 * Counts are derived from the data App.js already has on hand
 * (`stats.stationCount` and the cumulative reading_count summed
 * across stationStats when available; otherwise just the station
 * count).
 *
 * DOI is configured via REACT_APP_DATA_DOI; if unset, the strip
 * reads "DOI: pending" with a link to the latest CSV instead.
 */
const DATA_DOI = process.env.REACT_APP_DATA_DOI;
const DATA_DOI_URL = DATA_DOI ? `https://doi.org/${DATA_DOI}` : null;

const HomeStrip = ({ stationCount, readingCount, onOpenData }) => {
  return (
    <div className="home-strip" role="contentinfo">
      <span className="home-strip-stat">
        <strong>{stationCount.toLocaleString()}</strong> station{stationCount === 1 ? '' : 's'}
      </span>
      {readingCount > 0 && (
        <>
          <span className="home-strip-sep">·</span>
          <span className="home-strip-stat">
            <strong>{readingCount.toLocaleString()}</strong> readings
          </span>
        </>
      )}
      <span className="home-strip-sep">·</span>
      <a
        href="https://creativecommons.org/licenses/by/4.0/"
        target="_blank" rel="noopener noreferrer"
        className="home-strip-link"
      >
        CC-BY-4.0
      </a>
      <span className="home-strip-sep">·</span>
      {DATA_DOI_URL ? (
        <a href={DATA_DOI_URL} target="_blank" rel="noopener noreferrer" className="home-strip-link">
          DOI: {DATA_DOI}
        </a>
      ) : (
        <button className="home-strip-link" onClick={onOpenData}>
          DOI: pending — see Data
        </button>
      )}
    </div>
  );
};

export default HomeStrip;
